import React, { useContext, useEffect } from "react";
import { useStaticQuery, graphql } from "gatsby";
import tw from "twin.macro";
import Memos from "./memos";
import Event from "./event";
import Hero from "../hero";
import Tabs from "../tabs";

import UpdatesContext from "./context";

const tabs = [
  { label: "News", active: false, to: "/updates" },
  { label: "Newsletters", active: false, to: "/updates/newsletters" },
  { label: "Meetings and Events", active: true, to: "/updates/events" },
  {
    label: "Funding Opportunities",
    active: false,
    to: "/updates/funding-opportunities"
  }
];

const EventList = tw.div``;
const PageContainer = tw.div`my-8 container mx-4 sm:mx-auto flex flex-col lg:flex-row justify-between w-full`;
const Sidebar = tw.aside`lg:w-3/12 mt-8 px-4 lg:px-0`;
const SidebarHeading = tw.h3`text-red-900 pl-2 -ml-4 border-l-8 border-red-900 font-bold uppercase`;
const SidebarSection = tw.div`mb-8`;

const Events = () => {
  const updatesContext = useContext(UpdatesContext);
  const { loading, error, getEvents, events } = updatesContext;

  const data = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "news-banner.jpeg" }) {
        childImageSharp {
          fluid(maxWidth: 1440) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);

  useEffect(() => {
    getEvents();
    //eslint-disable-next-line
  }, []);

  return (
    <>
      <Hero imgQuery={data.file.childImageSharp.fluid}>Meetings and Events</Hero>
      <div tw="bg-gray-100">
        <div tw="container mx-4 sm:mx-auto">
          <Tabs tabs={tabs} />
        </div>
      </div>
      <PageContainer>
        <EventList>
          {loading
            ? "Loading..."
            : error
            ? error
            : events.map((event, i) => (
                <Event
                  key={`event-${i}`}
                  title={event.title}
                  date={event.date}
                  location={event.location}
                  href={event.website}
                />
              ))}
        </EventList>
        <Sidebar>
          <SidebarSection>
            <SidebarHeading>Steering Committee Memos</SidebarHeading>
            <Memos />
          </SidebarSection>
        </Sidebar>
      </PageContainer>
    </>
  );
};

export default Events;
